import Vue from 'vue'
import iaConfig from 'widgets/instant-answers/instant-answers.config'
import AskTips from './ask-tips'
import HintText from 'objects/hint/hint-text'
import SearchField from 'objects/form/search-field'

import withRender from './ask.html'
import './ask.scss'

export default withRender(Vue.extend({
  data() {
    return { showLearnMore: false }
  },
  components: {
    'tt-ask-tips': AskTips,
    'tt-hint-text': HintText,
    'tt-search-field': SearchField
  },
  props: {
    alertText: { type: String },
    countText: { type: String },
    errorText: { type: String },
    inAskMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    askLabel() {
      return this.$msg(this.inAskMode ? 'ia.askLabel' : 'ia.promptLabel')
    },
    askLabelMobile() {
      return this.$msg(this.inAskMode ? 'ia.askLabel.mobile' : 'ia.promptLabel.mobile')
    },
    hintSeparator() {
      return ' <span class="tt-o-hint__dot">' + this.$msg('hint.error.separator') + '</span> '
    },
    hintText() {
      if (this.errorText) {
        return this.errorText
      }
      if (this.alertText) {
        return this.alertText
      }
      if (this.inAskMode) {
        return (this.countText ?
          this.countText + this.hintSeparator : '') + this.$msg('ia.askHint')
      }
      return this.value ? '' :
        (this.countText ? this.countText + this.hintSeparator : '') + this.$msg('ia.promptHint')
    },
    hintType() {
      return this.errorText ? 'error' : (this.alertText ? 'alert' : 'info')
    },
    learnMoreText() {
      return this.showLearnMore ? this.$msg('ia.hideTipsLink') : this.$msg('ia.learnMoreLink')
    },
    showLearnMoreLink() {
      return iaConfig.learnMoreEnabled && !this.alertText && !this.inAskMode && !this.value
    }
  },
  methods: {
    clearText() {
      this.$emit('input', '')
      this.$refs.searchFieldComponent.clearText()
    },
    toggleLearnMore() {
      this.showLearnMore = !this.showLearnMore
    },
    update(value) {
      this.$emit('input', value)
      if (value && this.showLearnMore) {
        this.showLearnMore = false
      }
    }
  }
}))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/components/ask/ask.ts